import * as React from 'react';
import * as styles from './styles.css';
import { Checkbox } from '../../../Checkbox';
import { IDropdownOption } from '../../../../types/dropdown';
import { Typography } from '../../../Typography';
import { Title } from '../../../Typography/components';
import { Button } from '../../../Button';
import { Modal } from '../../../Modal';
import { StickyActions } from '@cian/frontend-e2e-deal-component';
import cn from 'clsx';
import { useDeviceType } from '@cian/ui-kit';

interface IDropdownProps {
  list: IDropdownOption[];
  isOpen?: boolean;
  isMultiselect: boolean;
  checkIsOptionSelected: (item: IDropdownOption) => boolean;
  handleSelect: (state: boolean, item: IDropdownOption) => void;
  title: string;
  handleClose: () => void;
  handleReset: () => void;
}

//TODO: Добавить отрисовку списка, когда пользователь может выбрать только один option из списка (isMultiselect === false)
export const SelectModal: React.FC<IDropdownProps> = ({
  list,
  handleReset,
  handleSelect,
  checkIsOptionSelected,
  title,
  isOpen,
  handleClose,
}) => {
  const deviceType = useDeviceType();
  const handleResetButtonClick = () => {
    handleReset();
    handleClose();
  };

  const stickyClassNames = {
    actionArea: cn(styles['action-area'], styles[deviceType]),
    actionAreaWhenStuck: styles['action-area-when-sticky'],
    actionWrapperWhenStuck: styles['action-wrapper-when-sticky'],
  };

  return (
    <Modal
      header={
        <div className={styles.header}>
          <Title level={6}>{title}</Title>
        </div>
      }
      isOpen={!!isOpen}
      onClose={handleClose}
    >
      <div className={styles['list']}>
        <ul className={styles['options']}>
          {list.map(item => {
            return (
              <li className={styles['options-checkbox']} key={item.value}>
                <Checkbox
                  isChecked={checkIsOptionSelected(item)}
                  setChecked={state => handleSelect(state, item)}
                  label={item.label}
                  id={item.value}
                />
              </li>
            );
          })}
          {!list.length && (
            <li className={styles['not-found']}>
              <Typography.Text level={3}>Ничего не найдено</Typography.Text>
            </li>
          )}
        </ul>
      </div>
      <StickyActions
        deviceTypesWithSticky={['tablet', 'phone']}
        position={'sticky'}
        stickyClassNames={stickyClassNames}
      >
        <div className={styles.buttons}>
          <Button fullWidth theme="fill_secondary" onClick={handleResetButtonClick}>
            Сбросить
          </Button>

          <Button fullWidth onClick={handleClose}>
            Применить
          </Button>
        </div>
      </StickyActions>
    </Modal>
  );
};
